import { createGlobalStyle } from "styled-components";
import sky from "./img/wp10989489.webp"; // замените на путь к новой картинке

export const GlobalStyle = createGlobalStyle`
     :root {
          --transition: 300ms ease;
          --body-background: #f7fafc; /* нейтральный светлый фон */
          --body-background-50: rgba(247, 250, 252, 0.5); /* светлый фон с прозрачностью */
          --body-background-75: rgba(247, 250, 252, 0.75); /* светлый фон с прозрачностью */
          --second-background: rgba(230, 238, 241, 0.85); /* холодный светло-серый */
          --color: #223344; /* темно-синий текст для контраста */
          --second-color: #5a7a8c; /* приглушенный сине-серый */
          --accent: rgba(20, 150, 2, 1); /* насыщенный зелёный акцент */
          --accent-50: rgba(20, 150, 2, 0.5); /* насыщенный зелёный акцент с прозрачностью */
          --accent-40: rgba(20, 150, 2, 0.4); /* насыщенный зелёный акцент с прозрачностью */
          --accent-30: rgba(20, 150, 2, 0.3); /* насыщенный зелёный акцент с прозрачностью */
          --accent-20: rgba(20, 150, 2, 0.2); /* насыщенный зелёный акцент с прозрачностью */
          --accent-10: rgba(20, 150, 2, 0.1); /* насыщенный зелёный акцент с прозрачностью */
          --accent-05: rgba(20, 150, 2, 0.05);
     }

     html {
          scroll-behavior: smooth;
     }

     [id] {
          scroll-margin-top: 80px;
     }

     body {
          font-family: 'Gilroy', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
          'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
          sans-serif;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          color: var(--color);
          fill: var(--color);
          background: linear-gradient(
               rgba(247, 250, 252, 0.65),
               rgba(247, 250, 252, 0.65)
          ),
          url(${sky});
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat; 
          background-attachment: fixed;
     }

     a {
          text-decoration: none;
          color: inherit;
     }

     h1, h2, h3, h4, h5, h6 {
          margin: 0;
          font-weight: 500;
          color: var(--color);
     }

     ul {
          list-style-type: none;
          padding: 0;
     }

     img {
          max-width: 100%;
     }    

     code {
          font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
          monospace;
     }

     input::-webkit-outer-spin-button,
     input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
     }

     svg {
          fill: inherit;
          stroke: inherit
     }

     .section {
          padding: 100px 0;
          background: var(--second-background);
     }

     .styled-button {
          background: var(--accent);
          border-radius: 4rem;
          padding: 1rem 1.5rem;
          color: #fff;
          font-weight: 500;
          line-height: normal;
          transition: all 0.3s;
          text-align: center;
          white-space: nowrap;

          &:hover {
          box-shadow: 0 0 8px 0 var(--accent);
          background: var(--accent);
          }

          @media (max-width: 1199px) {
          padding: 8px 24px;
          font-size: 16px;
          margin-left: 16px;
          }
          @media (max-width: 991px) {
          padding: 7px 18px;
          font-size: 15px;
          margin-left: 8px;
          }
     }
     
`;
